import { Pricing } from './Pricing';

const options = {
  Pricing
};
export default options;
